export default __webpack_public_path__ + "static/media/sohail.59e79acf.jpg";